/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { safeFilterActions } from '@zcode/utils'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { lifestylesReducer } from './reducer'
import { whitelist } from './whitelist'

export const lifestyles = safeFilterActions<
  ReturnType<typeof lifestylesReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(lifestylesReducer, whitelist)
